import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";
import {
  SEND_SOLICITACAO_EMAIL,
  FETCH_ALL,
  SEND_RENT,
  CLEAR_ALL,
  FETCH_ALL_CSV
} from "@/store/actions/actions.type";
import {
  SEND_SOLICITACAO_EMAIL_START,
  SEND_SOLICITACAO_EMAIL_END,
  SEND_RENT_START,
  SEND_RENT_END,
  FETCH_ALL_CSV_START,
  FETCH_ALL_CSV_END,
  FETCH_ALL_START,
  FETCH_ALL_END,
  SET_ALL_MYDISCIPLINAS,
  UNSET_ALL
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  rents: {
    current_page: 1,
    per_page: 10,
    data: [],
    filters: []
  },
  myDisciplinas: {
    current_page: 1,
    per_page: 10,
    data: [],
    filters: []
  }
});

const state = {
  solicitacao: {
    //Não usar tipo de dado Set em disciplinas. Seria perfeito para nao deixar duplicar, mas o vue.js 2 não suporta reatividade em Map e Set.
    disciplinas: {
      data: []
    },
    observacoes: ""
  },
  rents: object.clone(defaults.rents),
  myDisciplinas: object.clone(defaults.myDisciplinas),
  lastDisciplinaRemoved: {},
  isSendingSolicitacaoEmail: false,
  isSendingRent: false,
  isFetchingRents: false,
  isFetchingCsvDisciplinas: false
};
const getters = {
  isFetchingDisciplinas(state) {
    return state.isFetchingDisciplinas;
  },
  isFetchingCsvDisciplinas(state) {
    return state.isFetchingCsvDisciplinas;
  },
  myDisciplinas(state) {
    return state.myDisciplinas;
  },
  rents(state) {
    return state.rents;
  },
  isFetchingRents(state) {
    return state.isFetchingRents;
  },
  solicitacao(state) {
    return state.solicitacao;
  },
  isSendingSolicitacaoEmail(state) {
    return state.isSendingSolicitacaoEmail;
  },
  isSendingRent(state) {
    return state.isSendingRent;
  }
};

const actions = {
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);
      ApiAdmin.query("rents/list", params)
        .then(response => {
          context.commit(SET_ALL_MYDISCIPLINAS, response.data);
          resolve(response.data);
        })
        .catch(e => {
          console.log(e);
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },
  [SEND_RENT](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SEND_RENT_START);

      ApiAdmin.post("rents/add", params)
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(SEND_RENT_END);
        });
    });
  },
  [SEND_SOLICITACAO_EMAIL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SEND_SOLICITACAO_EMAIL_START);

      ApiAdmin.post("solicitacoes/sendmail", params)
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(SEND_SOLICITACAO_EMAIL_END);
        });
    });
  },
  [FETCH_ALL_CSV](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_CSV_START);

      ApiAdmin.query("rents/list", params)
        .then(response => {
          var blob = new Blob([response.data], {
            type: "text/csv"
          });
          var url = window.URL.createObjectURL(blob);

          var anchor = document.createElement("a");
          anchor.href = url;
          var date = new Date().toLocaleDateString("pt-BR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          });
          anchor.download = `EaDStock - Disciplinas ${date}`;
          anchor.click();
          resolve();
        })
        .catch(e => {
          reject(e.response);
        })
        .finally(() => {
          context.commit(FETCH_ALL_CSV_END);
        });
    });
  },
  [CLEAR_ALL](context) {
    return new Promise(resolve => {
      context.commit(UNSET_ALL);
      resolve();
    });
  },
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingDisciplinas = true;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingDisciplinas = false;
    state.isFetchingRents = true;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingRents = false;
  },
  [SEND_RENT_START](state) {
    state.isSendingRent = true;
  },
  [SEND_RENT_END](state) {
    state.isSendingRent = false;
  },
  [SET_ALL_MYDISCIPLINAS](state, myDisciplinas) {
    state.myDisciplinas = myDisciplinas;
  },
  [FETCH_ALL_CSV_START](state) {
    state.isFetchingCsvDisciplinas = true;
  },
  [FETCH_ALL_CSV_END](state) {
    state.isFetchingCsvDisciplinas = false;
  },
  [UNSET_ALL](state) {
    state.myDisciplinas = object.clone(defaults.myDisciplinas);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
